// Copyright © 2021 Move Closer
import { TokenType } from '@d24/demarked';
import { ModuleDriver } from '../_contracts';
import { getModuleBase } from '../_helpers/adapter';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export class HRAdapter {
    /**
     * Adapts (translates/maps) the passed-in `HRModule` to the `HRToken`.
     *
     * @param object - The module to adapt.
     */
    objectToToken(object) {
        const { content } = object;
        if (typeof content !== 'object') {
            throw new Error(`HRAdapter.objectToToken(): [object.content] property should be an [object], but got ${typeof content}!\nFull [object] object: ${JSON.stringify(object)}`);
        }
        const { text } = content;
        if (typeof text !== 'string') {
            throw new Error(`HRAdapter.objectToToken(): [object.content.text] property should be a [string], but got ${typeof text}!\nFull [object] object: ${JSON.stringify(object)}`);
        }
        return {
            content: text,
            raw: text,
            type: TokenType.HR
        };
    }
    /**
     * Adapts (translates/maps) the passed-in `HRToken` to the `HRModule`.
     *
     * @param token - The token to adapt.
     */
    tokenToObject(token) {
        const { content } = token;
        if (typeof content !== 'string') {
            throw new Error(`HRAdapter.tokenToObject(): [token.content] property should be a [string], but got ${typeof content}!\nFull [token] object: ${JSON.stringify(token)}`);
        }
        return {
            ...getModuleBase(),
            content: { text: content },
            driver: ModuleDriver.HR
        };
    }
}
